import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { sitename } from "constants/constants"
import { getAffiliatesCall } from "helpers/repository"
import { showErrorMessages } from "helpers/helpers"
import AffiliatesTable from "pages/Reports/RefferalReport/AffiliatesTable"

const AffiliateParameters = () => {
  const [affiliates, setAffiliates] = useState([])
  const [pagination, setPagination] = useState(null)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")

  const fetchAffiliates = async () => {
    setLoading(true)
    try {
      const response = await getAffiliatesCall({ page, search, per_page: 15 })
      const result = response?.data?.data || {}

      setAffiliates(result.data || [])
      setPagination(result.pagination || null)
    } catch (error) {
      showErrorMessages(error)
      setAffiliates([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAffiliates()
  }, [page])

  useEffect(() => {
    if (page !== 1) {
      setPage(1)
      return
    }
    const timeout = setTimeout(() => {
      fetchAffiliates()
    }, 400)
    return () => clearTimeout(timeout)
  }, [search])

  return (
    <div className="page-content">
      <MetaTags>
        <title>{sitename}</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title="Affiliate" breadcrumbItem="Parameters / Settings" />
        <Card>
          <CardBody>
            <Row>
              <Col sm={4}>
                <div className="search-box me-2 mb-2 d-inline-block w-100">
                  <div className="position-relative">
                    <Input
                      type="text"
                      placeholder="Search by phone number, username, or referral code"
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                    />
                    <i className="bx bx-search-alt search-icon" />
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <AffiliatesTable
          data={affiliates}
          loading={loading}
          pagination={pagination}
          page={page}
          setPage={setPage}
        />
      </Container>
    </div>
  )
}

export default AffiliateParameters
